'use strict';

var cov_xdl6l67e7 = function () {
  var path = 'D:\\raw\\vina_giaitri365\\vnp_365_client\\src\\app\\footer.js',
      hash = 'd591bc97e6fa333f930bb80bbb97e487a00ef448',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\raw\\vina_giaitri365\\vnp_365_client\\src\\app\\footer.js',
    statementMap: {
      '0': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 15,
          column: 6
        }
      },
      '1': {
        start: {
          line: 5,
          column: 22
        },
        end: {
          line: 5,
          column: 28
        }
      },
      '2': {
        start: {
          line: 6,
          column: 6
        },
        end: {
          line: 14,
          column: 7
        }
      },
      '3': {
        start: {
          line: 9,
          column: 8
        },
        end: {
          line: 9,
          column: 31
        }
      },
      '4': {
        start: {
          line: 13,
          column: 8
        },
        end: {
          line: 13,
          column: 24
        }
      },
      '5': {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 18,
          column: 7
        }
      },
      '6': {
        start: {
          line: 17,
          column: 6
        },
        end: {
          line: 17,
          column: 39
        }
      },
      '7': {
        start: {
          line: 23,
          column: 0
        },
        end: {
          line: 28,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 3,
            column: 3
          }
        },
        loc: {
          start: {
            line: 3,
            column: 93
          },
          end: {
            line: 20,
            column: 3
          }
        },
        line: 3
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 4,
            column: 24
          },
          end: {
            line: 4,
            column: 25
          }
        },
        loc: {
          start: {
            line: 4,
            column: 36
          },
          end: {
            line: 15,
            column: 5
          }
        },
        line: 4
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 16,
            column: 48
          },
          end: {
            line: 16,
            column: 49
          }
        },
        loc: {
          start: {
            line: 16,
            column: 59
          },
          end: {
            line: 18,
            column: 5
          }
        },
        line: 16
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 6,
            column: 6
          },
          end: {
            line: 14,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 6,
            column: 6
          },
          end: {
            line: 14,
            column: 7
          }
        }, {
          start: {
            line: 6,
            column: 6
          },
          end: {
            line: 14,
            column: 7
          }
        }],
        line: 6
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0
    },
    b: {
      '0': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MainController =
/** @ngInject */
function MainController($scope, moment, $http, apiOpen, $rootScope, $window, $anchorScroll, $location) {
  _classCallCheck(this, MainController);

  cov_xdl6l67e7.f[0]++;
  cov_xdl6l67e7.s[0]++;

  $scope.gotoAnchor = function () {
    cov_xdl6l67e7.f[1]++;

    var newHash = (cov_xdl6l67e7.s[1]++, 'body');
    cov_xdl6l67e7.s[2]++;
    if ($location.hash() !== newHash) {
      cov_xdl6l67e7.b[0][0]++;
      cov_xdl6l67e7.s[3]++;

      // set the $location.hash to `newHash` and
      // $anchorScroll will automatically scroll to it
      $location.hash('body');
    } else {
      cov_xdl6l67e7.b[0][1]++;
      cov_xdl6l67e7.s[4]++;

      // call $anchorScroll() explicitly,
      // since $location.hash hasn't changed
      $anchorScroll();
    }
  };
  cov_xdl6l67e7.s[5]++;
  $http.get(apiOpen + 'categories/list').then(function (results) {
    cov_xdl6l67e7.f[2]++;
    cov_xdl6l67e7.s[6]++;

    $scope.categories = results.data;
  });
};

cov_xdl6l67e7.s[7]++;


angular.module('app').component('fountainFooter', {
  templateUrl: 'app/footer.html',
  controller: MainController
});